<script src="https://maps.googleapis.com/maps/api/js?key=AIzaSyCYhrPPXqLZhGjfoHH_fouEOOcmOuCv3Q4&callback=test"></script>
<script>
function test(){
	debugger
	var mapProp={center:new google.maps.LatLng(51.508742,-0.120850),zoom:5};
	var map = new google.maps.Map(document.getElementById("map-container"),mapProp);}
</script>
<div id="dashboard" class="step-page">
	<div class="step-title">
		<div class="line-left">Layer Summary</div>
		<div class="line-right">
			<button *ngIf="isAdmin" class="button-general" (click)="newJob()">Upload</button>
			<app-feat-download-layers *ngIf="showDownloadBtn"></app-feat-download-layers>
		</div>
	</div>
	<div class="step-content">
		<div class="tab-section">
			<app-feature-vertical-tabs #verticalTabs [tabs]="tabList" (changeTab)="onChangeTab($event)"></app-feature-vertical-tabs>
		</div>
		<app-feat-d3-statistics></app-feat-d3-statistics>
		<div class="jobs-list">
			<div class="jobs-title-row">
				<div class="jobs-title">Transaction Log</div>
				<!-- <div class="jobs-search">
					<input name="transc-search" placeholder="Search..." [(ngModel)]="transcSearchStr" (ngModelChange)="searchTransc()">
					<i class="glyphicons glyphicons-search"></i>
				</div> -->
			</div>
			<div class="jobs-table">
				<div class="table-header">
					<div class="table-row">
						<ng-container *ngFor="let col of jobsColumns; let idx = index;">
							<div class="table-th" 
								(click)="clickHeader(idx)">
								{{col.name}}
								<i *ngIf="col===sortedCol" class="glyphicons glyphicons-play" [ngClass]="{'rotate-down':col.sortOrder===1, 'rotate-up':col.sortOrder===-1}"></i>
							</div>
						</ng-container>
					</div>
				</div>
				<div class="table-body">
					<div class="table-row" 
						*ngFor="let transc of transactionInfo?.transactions; let idx = index;" 
						(click)="clickTransc(idx)">
						<div class="table-td">
							<div>
								{{transc.startTime}}
							</div>	
						</div>
						<div class="table-td">
							<div class="table-row-files">
								<div class="load-files">
									<i 
									class="glyphicons" 
									[ngClass]="{'glyphicons-plus': !transc.isExpanded, 'glyphicons-minus': transc.isExpanded }" 
									(click)="transc.isExpanded=!transc.isExpanded;">
									</i>
									<div class="expand-title">Files</div>
									<div class="expand-content" *ngFor="let file of transc.details" [hidden]="!transc.isExpanded">
										<i 
											class="glyphicons" 
											[ngClass]="{'glyphicons-plus': !file.isExpanded, 'glyphicons-minus': file.isExpanded }" 
											(click)="file.isExpanded=!file.isExpanded;">
										</i>
										<div class="expand-title">{{file.fileName}}</div>
										<div class="expand-content-last" *ngFor="let layer of file.layers" [hidden]="!file.isExpanded">
											{{layer.name}}
										</div>
									</div>									
								</div>
								<div class="load-logs">
									<div class="button-general button-general-yes" title="View loading logs" (click)="toggleLoadingLogs(true, transc)">
										<i class="glyphicons glyphicons-info-sign"></i>
										<div>details</div>
									</div>
								</div>
							</div>
						</div>
						<div class="table-td">
							<div>
								{{transc.type}}
							</div>
						</div>
						<div class="table-td">
							<div>
								{{transc.userName}}
							</div>
						</div>	
					</div>
				</div>
			</div>
			<app-common-table-paging
				#tablePaging
				[isPaging]="true"
				[totalNum]="total"
				[pageSize]="paging.pageSize"
				[footerHeight]="paging.footerHeight"
				(paging)="setPage($event)">
			</app-common-table-paging>	
		</div>
	</div>
</div>


<div #LogsPopup *ngIf="showLogsPopup" class="loading-logs-popup">
	<div class="popup-top-bar">
		<i class="glyphicons glyphicons-remove" (click)="toggleLoadingLogs(false)"></i>
	</div>
	<div class="popup-content">
		<div *ngIf="transcLogs&&transcLogs.length">
			<div *ngFor="let log of transcLogs">
				<div *ngIf="log.type==='print'" class="log-item">
					<div class="log-timestamp">{{log.timeStamp}} &nbsp;&nbsp;</div>
					<div class="log-message">
							{{log.message}}
					</div>
				</div>
				<div *ngIf="log.type==='json'">
					<div *ngFor="let msg of log.message" class="log-item" [ngClass]="{'err-msg': msg.type==='err'}">
						<div class="log-timestamp">{{msg.time}} &nbsp;&nbsp;</div>
						<div class="msg-content">
								{{msg.msg}}
						</div>
					</div>
				</div>
			</div>
		</div>
		<div *ngIf="!transcLogs||!transcLogs.length" class="no-log">
			<div>No transaction details to display</div>
		</div>
	</div>
	<div class="popup-bottom-bar"></div>
</div>
<!-- <div #DownloadPopup *ngIf="showDownloadPopup" class="download-popup">
	<div class="popup-top-bar">
		<i class="glyphicons glyphicons-remove" (click)="toggleDownloadPopup(false)"></i>
	</div>
	<div class="popup-content">
		<div class="download-popup-item download-popup-item-header">
			<div>Layer</div>
			<div>
				<input name="download-popup-all" type="checkbox" [(ngModel)]="isPopupDownloadAll" (ngModelChange)="togglePopupDownloadAll()">
			</div>
		</div>
		<div *ngFor="let layer of downloadableLayers; let idx = index;" class="download-popup-item">
			<div>{{layer.name}}</div>
			<div>
				<input name="download-layer-{{idx}}" type="checkbox" [(ngModel)]="layer.isDownload">
			</div>
		</div>
		<div class="popup-download-btn">
			<button class="button-general" (click)="clickPopupDownload()">Download</button>
		</div>
	</div>
	<div class="popup-bottom-bar"></div>
</div> -->

<ng-template #tabSnap>
	<!-- <div class="row-wrap">
		<div class="row-right btn-groups">
			<button *ngIf="selectedCustomerId===customerId||customerType==='integrator'" class="button-general" (click)="newJob()" title="Upload layers">Load</button>
			<button class="button-general" title="Down load layer fgdb files" [disabled]="disableDownloadBtn()" (click)="clickDownload()">Download</button>
			<button class="button-general" (click)="clickQc()" title="Run QC">QC View</button>
			<button *ngIf="customerType!=='integrator'&&isAdmin&&parentCusId&&selectedCustomerId===customerId" class="button-general" [disabled]="!selectedLayer?.submitStatus||selectedLayer?.submitStatus.hasError" [title]="selectedLayer?.submitStatus?.msg" (click)="submitLayer()">Submit</button>
			<button *ngIf="customerType==='integrator'&&isAdmin&&parentCusId_integratorClient" class="button-general" [disabled]="!selectedLayer?.submitStatus||selectedLayer?.submitStatus.hasError" [title]="selectedLayer?.submitStatus?.msg" (click)="submitLayer()">Submit</button>

		</div>
	</div> -->
	<div #summaryTableContainer class="summary-table-container">
		<app-common-datagrid
			#summaryTable
			[columns]="columns"
			[rows]="rows"
			[selectedRows]="selectedRows"
			[rowH]="40"
			[rowClass]="setRowClass"
			[isPaging]="false"
			[hidePaging]="true"
			(select)="clickLayer($event)"
		></app-common-datagrid>
	</div>
</ng-template>
<ng-template #tabMaintain>
	<app-common-datagrid
		#snapTable
		[columns]="columns_maintain"
		[rows]="rows_maintain"
		[columnMode]="'force'"
		[selectedRows]="selectedRows_maintain"
		[rowH]="40"
		[isPaging]="false"
		[hidePaging]="true"
		(select)="clickLayer_maintain($event)"
	></app-common-datagrid>
</ng-template>

<ng-template #layerStateHeaderTempl>
	<div class="status-header" [style.width]="isAdmin?'calc(44% - 72px)':'calc(44% - 20px)'">
		<!-- <div>MISSING</div><hr> -->
		<div class="status-header-inner" *ngFor="let header of layerStatesHeader;let idx = index;">
			<div style="display: flex;">
				<div class="status-header-label">{{header.display}}</div>
				<div style="flex-grow:1;" *ngIf="idx !== layerStatesHeader.length - 1"><hr></div>
			</div>
		</div>
		<!-- <div>Created</div><hr>
		<div>QA/QC</div><hr>
		<div>SUBMITTED</div><hr>
		<div>DISAPPROVED</div><hr>
		<div>APPROVED</div> -->
	</div>
</ng-template>
<ng-template #layerStateTempl let-value="value">
	<div *ngIf="value>0" style="margin-top:-6px;">
		<mat-slider disabled min="1" max="5" step="1" [value]="value" style="width:100%;">
		</mat-slider>
	</div>
	<div *ngIf="value<=0">
		<hr>
	</div>
</ng-template>
<ng-template #layerOwnerTempl let-row="row" let-column="column">
	<div>
		<i *ngIf="!row[column.prop]" class="glyphicons glyphicons-building"></i>
		<i *ngIf="row[column.prop]" class="glyphicons glyphicons-flag"></i>
	</div>
</ng-template>
<ng-template #operationsTempl let-row="row">
	<div *ngIf="selectedCustomerId===customerId||customerType==='integrator'" class="operation-templ">
		<ng-container *ngIf="selectedTab.key === 'snap'">
			<div *ngIf="isAdmin&&row[layerCateCodeCol.prop]==='ROADCL'&&row[layerStateCol.prop].num>=2" class="send-btn button-general button-general-yes" [ngClass]="{'btn-disabled': isSending}" title="Send layer to Data Supply-Chain" (click)="sendToDataSupplyChain()">
				<i class="glyphicons glyphicons-send"></i>
				<span>AZGeo</span>
			</div>
			<div *ngIf="row[layerStateCol.prop].num>=1" class="download-btn button-general button-general-yes" [ngClass]="{'btn-disabled': isDownloading}" title="Download layers FGDB" (click)="downloadLayers()">
				<i class="glyphicons glyphicons-cloud-download"></i>
				<span [ngClass]="{'loading-dots': isDownloading}">{{isDownloading ? '' : 'Layer'}}</span>
			</div>
			<div *ngIf="row[layerStateCol.prop].num>=2" class="download-btn button-general button-general-yes" [ngClass]="{'btn-disabled': isDownloadingQC}" title="Download QC report" (click)="downloadQC()">
				<i class="glyphicons glyphicons-cloud-download"></i>
				<span [ngClass]="{'loading-dots': isDownloadingQC}">{{isDownloadingQC ? '' : 'QC'}}</span>
			</div>
			<!-- hide build-topology for now -->
			<div *ngIf="false&&row[isBuiltTopoCol] === false" class="icon-container" title="Build Topology">
				<i class="glyphicons glyphicons-claw-hammer" (click)="buildTopo()"></i>
			</div>
			<div *ngIf="isAdmin&&row[layerStateCol.prop].num===3" class="revoke-btn button-general button-general-no" title="Withdraw the submitted layer" (click)="revokeSubmittedLayer()">
				<i class="glyphicons glyphicons-undo"></i>
				<span>Revoke</span>
			</div>
			<!-- <div *ngIf="isAdmin&&row[layerStateCol.prop]&&row[layerStateCol.prop]<3" class="icon-container" title="Delete uploaded layer" style="text-align:center;">
				<i class="glyphicons glyphicons-remove" (click)="removeLayer(rows.indexOf(row))"></i>
			</div> -->
		</ng-container>
		<ng-container *ngIf="selectedTab.key === 'maintain'">
			<div *ngIf="isAdmin&&row[layerStateCol.prop].num===2&&row[layerCusIdColName]===customerId&&(row[layerMaintainTypeCol.prop]==='LIVE'||row[layerMaintainTypeCol.prop]==='REPLICA'||row[layerMaintainTypeCol.prop]==='COLLABORATIVE')" class="snap-btn button-general button-general-yes button-small" [ngClass]="{'btn-disabled': getDisableStatus(row), 'loading-dots': row[isPublishingCol]}" title="" (click)="getDisableStatus(row) ? null : publish(row)">
				<span>{{row[isPublishingCol] ? ' ' : 'Publish'}}</span>
			</div>
			<!-- <div *ngIf="isAdmin&&(row[layerMaintainTypeCol.prop]!=='COLLABORATIVE'||!parentCusId)" class="upload-btn button-plain" title="" (click)="newJob()">
				<i class="glyphicons glyphicons-cloud-upload"></i>
			</div> -->
		</ng-container>
	</div>
	<div *ngIf="selectedCustomerId!==customerId&&customerType!=='integrator'" class="operation-templ">
		<ng-container *ngIf="selectedTab.key === 'snap'">
			<div *ngIf="row[layerStateCol.prop].num===3" class="approve-reject-container">
				<button class="approve-btn button-general button-general-yes" title="Approve the submitted layer" (click)="approveSubmit(row)">Approve</button>
				<button class="reject-btn button-general button-general-no" title="Reject the submitted layer" (click)="rejectSubmit(row)">Reject</button>
			</div>
			<div *ngIf="isAdmin&&row[layerCateCodeCol.prop]==='ROADCL'&&row[layerStateCol.prop].num===5" class="send-btn button-general button-general-yes" [ngClass]="{'btn-disabled': isSending}" title="Send layer to Data Supply-Chain" (click)="sendToDataSupplyChain()">
				<i class="glyphicons glyphicons-send"></i>
				<span>AZGeo</span>
			</div>
			<div *ngIf="row[layerStateCol.prop].num>=3" class="download-btn button-general button-general-yes" [ngClass]="{'btn-disabled': isDownloading}" title="Download layers FGDB" (click)="downloadLayers()">
				<i class="glyphicons glyphicons-cloud-download"></i>
				<span [ngClass]="{'loading-dots': isDownloading}">{{isDownloading ? '' : 'Layer'}}</span>
			</div>
			<div *ngIf="row[layerStateCol.prop].num>=2" class="download-btn button-general button-general-yes" [ngClass]="{'btn-disabled': isDownloadingQC}" title="Download QC report" (click)="downloadQC()">
				<i class="glyphicons glyphicons-cloud-download"></i>
				<span [ngClass]="{'loading-dots': isDownloadingQC}">{{isDownloadingQC ? '' : 'QC'}}</span>
			</div>
			<div *ngIf="row[layerStateCol.prop].num===4||row[layerStateCol.prop].num===5" class="revoke-btn button-general button-general-no" title="{{row[layerStateCol.prop].num===4 ? 'Revoke disapproval' : 'Revoke approval'}}" (click)="revokeApproveOrReject()">
				<i class="glyphicons glyphicons-undo"></i>
				<span>Revoke</span>
			</div>
		</ng-container>
		<ng-container *ngIf="selectedTab.key === 'maintain'">

		</ng-container>
	</div>
</ng-template>
<ng-template #tooltipTempl let-row="row" let-value="value">
	<div [title]="row[tooltipCol]">{{value}}</div>
</ng-template>